import React from 'react';
import {Box, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import {styled} from '@mui/system';

const StyledText = styled(Typography)(() => ({
    display: 'inline',
    marginLeft: 1,
    fontSize: '0.9rem',
}));

const ChecklistBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
}));

export default function ChecklistItem({isPassed, text}) {
    const iconStyle = {marginRight: 0.6, fontSize: "1.2rem"};

    return <ChecklistBox>
        {isPassed ? <DoneIcon sx={iconStyle} /> : <CloseIcon sx={iconStyle} />}
        <StyledText>{text}</StyledText>
    </ChecklistBox>
};
